import { render, staticRenderFns } from "./carannualinspectioninformation.vue?vue&type=template&id=5061f3fa&scoped=true"
import script from "./carannualinspectioninformation.vue?vue&type=script&lang=js"
export * from "./carannualinspectioninformation.vue?vue&type=script&lang=js"
import style0 from "./carannualinspectioninformation.vue?vue&type=style&index=0&id=5061f3fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5061f3fa",
  null
  
)

export default component.exports